import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsListComponent } from '../../../comments-list/comments-list.component';
import { WhiteLabelUsersCommentsWithRate } from 'src/app/core/data/model';
import { ScoreboardListComponent } from '../../../scoreboard-list/scoreboard-list.component';

@Component({
  selector: 'app-pdf-page-two',
  standalone: true,
  imports: [CommonModule , CommentsListComponent , ScoreboardListComponent],
  templateUrl: './pdf-page-two.component.html',
  styleUrls: ['./pdf-page-two.component.scss']
})
export class PdfPageTwoComponent implements OnInit {
  @Input() commentsWithRate : WhiteLabelUsersCommentsWithRate;

  constructor() { }

  ngOnInit(): void {
  }

}
